import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { take } from 'rxjs';
import * as fromGraphQl from './graphql';

@Component({
  selector: 'app-time-entries-sum-view, [app-time-entries-sum-view]',
  templateUrl: './time-entries-sum-view.component.html',
  styleUrls: ['./time-entries-sum-view.component.scss'],
})
export class TimeEntriesSumComponent implements OnChanges {

  @Input() ownerId: string | undefined;

  @Input() label: string | undefined;

  public sum: number;

  constructor(
    private apollo: Apollo,
  ) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.ownerId) {
    this.apollo.query<fromGraphQl.TimeEntriesSumQueryResponse>({
      fetchPolicy: 'network-only',
      query: fromGraphQl.TIME_ENTRIES_SUM_QUERY,
      variables: {
        ownerId: this.ownerId
      },
    }).pipe(
      take(1)
    ).subscribe( (data) => {
      this.sum = data?.data?.timeEntriesSum;
    });
    }
  }

}
